var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showModalSkinHair)?_c('healthCare',{ref:"healthCare",on:{"closeHealthModal":function($event){_vm.showModalSkinHair = false}}}):_vm._e(),_c('WhatsappContact'),_c('div',{attrs:{"id":"mainDiv"}},[(
        (!_vm.mediaQueries.large || _vm.$route.name !== 'cart') &&
        _vm.$route.path != '/magazine' &&
        !_vm.$route.path.includes('/games/exam') &&
        !_vm.$route.path.includes('/games/birthday') &&
        !_vm.$route.path.includes('/wheel-of-fortune')
      )?_c('div',{staticClass:"w-100 header-banner"},[_c('router-link',{staticClass:"d-inline-block w-100 cursor-pointer",attrs:{"to":"/products?flash_id=65"}},[_c('img',{staticClass:"w-100 d-none d-md-block",attrs:{"src":require("@/assets/images/MONITOR.gif"),"alt":"advertise gif"}}),_c('img',{staticClass:"w-100 d-block d-md-none git-mobile",attrs:{"src":require("@/assets/images/slider_mobil-2.gif"),"alt":"advertise gif"}})])],1):_vm._e(),(
        _vm.$route.path != '/' &&
        !_vm.$route.path.includes('question-landing') &&
        _vm.$route.path != '/magazine' &&
        !_vm.$route.path.includes('/games/exam') &&
        !_vm.$route.path.includes('/games/birthday') &&
        !_vm.$route.path.includes('/wheel-of-fortune')
      )?_c('Header'):_vm._e(),_c('router-view',{key:_vm.$route.path}),(
        !_vm.$route.path.includes('question-landing') &&
        _vm.$route.path != '/magazine' &&
        !_vm.$route.path.includes('/games/exam') &&
        !_vm.$route.path.includes('/games/birthday') &&
        !_vm.$route.path.includes('/wheel-of-fortune')
      )?_c('Footer'):_vm._e()],1),_c('portal-target',{attrs:{"name":"productQuestionModalTarget","id":"productQuestionModalTarget"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status),expression:"status"}],attrs:{"id":"mainSpinner"}},[_c('Loading')],1),_c('Compare',{on:{"entered":function($event){_vm.showCompareContent = true}}}),_c('transition',{attrs:{"name":"fade"}},[(
        !_vm.mediaQueries.mobileSize &&
        Boolean(_vm.compares.length) &&
        _vm.showCompareContent
      )?_c('CompareContent',{on:{"left":function($event){_vm.showCompareContent = false}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }